// Tipos e helpers da GESTÃO DE CONTATOS (Fase 1). A API aceita sessão ou API key;
// o admin usa sessão via apiFetch (Authorization + X-Project-Id).
import type { BadgeProps } from '@/components/ui/badge';

export type ContactStatus =
  | 'active' | 'pending_validation' | 'opted_out' | 'blocked' | 'unreachable';

export interface ContactAddress {
  street?: string;
  number?: string;
  complement?: string;
  district?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
}

export interface Contact {
  id: string;
  chat_jid: string;
  phone: string;
  /** LID do WhatsApp ("<dígitos>@lid"), na ficha do contato. */
  lid?: string;
  /** BSUID da Meta (trilho oficial): o endereço de quem esconde o telefone. */
  bsuid?: string;
  name: string;
  email?: string;
  document?: string;
  document_type?: string;
  address?: ContactAddress;
  avatar_url?: string;
  instance_id?: string;
  status: ContactStatus;
  status_reason?: string;
  source?: string;
  message_count: number;
  opted_out_at?: string;
  last_message_at?: string;
  created_at?: string;
  updated_at?: string;
  tags: string[];
  groups: string[];
}

export interface HistoryItem {
  kind: 'message' | 'event';
  type: string;
  direction?: 'in' | 'out';
  status?: string;
  actor?: string;
  payload?: Record<string, unknown> & { body?: string; caption?: string; note?: string };
  created_at: string;
}

export interface Taxon {
  id: string;
  key: string;
  name: string;
  color?: string;
  count?: number;
  created_at?: string;
}

export interface Suppression {
  id: string;
  phone: string;
  reason?: string;
  source?: string;
  created_at?: string;
}

/** Status "com problema de recebimento" (atalho da UI). */
export const DELIVERY_ISSUE_STATUSES: ContactStatus[] = ['opted_out', 'blocked', 'unreachable'];

export const ALL_STATUSES: ContactStatus[] = [
  'active', 'pending_validation', 'opted_out', 'blocked', 'unreachable',
];

/** Cor do badge por status (usa as variantes do design system). */
export function statusVariant(status: ContactStatus): NonNullable<BadgeProps['variant']> {
  switch (status) {
    case 'active': return 'success';
    case 'pending_validation': return 'warning';
    case 'opted_out': return 'secondary';
    case 'blocked': return 'destructive';
    case 'unreachable': return 'warning';
    default: return 'outline';
  }
}

/** Identificação de exibição: o telefone; sem telefone, o LID ou o BSUID do endereço. */
export function contactIdent(c: { phone?: string; chat_jid?: string }, fmt: (p: string) => string): string {
  if (c.phone) return fmt(c.phone);
  if (c.chat_jid?.endsWith('@lid')) return c.chat_jid;
  if (c.chat_jid?.endsWith('@bsuid')) return c.chat_jid.slice(0, -'@bsuid'.length);
  return '';
}
